export default __webpack_public_path__ + "static/media/some0therguy1.7f746583.jpeg";